import { RestProvider } from '../../providers/rest/rest';
import { Component, Input, NgZone } from "@angular/core";
import { IonicPage, NavParams, NavController, ModalController, AlertController, LoadingController, Platform, ToastController } from 'ionic-angular';
import { OrdersProvider } from '../../providers/orders/orders';
import { AuthProvider } from '../../providers/auth/auth';
import {FileUploader, FileUploaderOptions, ParsedResponseHeaders} from 'ng2-file-upload';
//import { LoginPage } from '../login-page/login-page';
import { Storage } from '@ionic/storage';
import { GlobalProvider } from "../../providers/global/global";
/**
 * Generated class for the OrdersPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage({
    segment: 'order-list'
})
@Component({
  selector: 'page-orders',
  templateUrl: 'orders.html',
})
export class OrdersPage {

	orders: any;

  search_Order_Id: string;

  //Pagination
  res: any; //Pagination data
  // p: number = 1; //Pagination page
  //@Input('data') orders: string[] = [];
    //asyncMeals: Observable<string[]>;
    p: number = 1;
    per_page: number;
    total: number;
    //loading: boolean;
    uploader: FileUploader;
    uploadImageType:any;
    forImageId:any;
    forOrderId:any;
    responses: Array<any>;
    imageSwatch:any;
    hasBaseDropZoneOver: boolean;
    

  loader: boolean;
  loading: any;
  uploadProgress: number = 1;
	errorMessage: string;
  public devWidth = this.platform.width(); //returns screensize

  constructor(public navCtrl: NavController, public navParams: NavParams, public rest: RestProvider, 
    public orderService: OrdersProvider, public modalCtrl: ModalController,
    public alertCtrl: AlertController, public authService: AuthProvider, public loadingCtrl: LoadingController, 
    public platform: Platform, public toastCtrl: ToastController, public storage: Storage ,
    public global: GlobalProvider, private zone: NgZone) {
  }


  ionViewDidLoad() {

    this.getPage(1);

    this.responses = [];
    
    this.storage.get('token').then((token) => {

            const uploaderOptions: FileUploaderOptions = {            
                    url: this.global.apiUrl + 'upload-image',
                    autoUpload: true,
                    isHTML5: true,
                    removeAfterUpload: true,
                    headers: [
                        {
                            name: 'X-Requested-With',
                            value: 'XMLHttpRequest'
                        },
                        {
                            name: 'Authorization',
                            value: 'Bearer ' + token
                        }
                    ]
                };
                this.uploader = new FileUploader(uploaderOptions);

                // Add custom tag for displaying the uploaded photo in the list
                this.uploader.onBuildItemForm = (fileItem: any, form: FormData): any => {
                    //this.showLoader();
                    this.showSimpleLoader();
                    //form.append('upload_preset', this.cloudinary.config().upload_preset);
                    //let tags = 'myphotoalbum';
                    form.append('uploadImageType', this.uploadImageType);
                    form.append('image_id', this.forImageId);
                    form.append('order_id', this.forOrderId);

                    if (this.global.has_stream) {
                      form.append('action_for_admin_id', this.global.action_for_admin_id);
                    }
                    

                    if (this.imageSwatch) {
                      form.append('swatch_type', this.imageSwatch.type);
                      form.append('swatch_value', this.imageSwatch.value);
                    }
                    
                    //form.append('tags', tags);
                    console.log('FILE ITEM', fileItem);
                    form.append('file', fileItem);

                    fileItem.withCredentials = false;
                    return { fileItem, form };
                };

                // Insert or update an entry in the responses array
                const upsertResponse = fileItem => {

                    // Run the update in a custom zone since for some reason change detection isn't performed
                    // as part of the XHR request to upload the files.
                    // Running in a custom zone forces change detection 
                    
                    this.zone.run(() => {
                        // Find the id of an existing item
                        const existingId = this.responses.reduce((prev, current, index) => {
                            if (current.file.name === fileItem.file.name && !current.status) {
                                console.log('Index:', index);
                                console.log(this.responses);
                                return index;
                            }
                            return prev;
                        }, -1);
                        if (existingId > -1) {
                            // Update existing item with new data
                            this.responses[existingId] = Object.assign(this.responses[existingId], fileItem);
                        } else { 
                            // Create new response
                            this.responses.push(fileItem);                    
                        }
                    });
                };

                this.uploader.onCompleteItem = (item: any, response: string, status: number, headers: ParsedResponseHeaders) =>


                 {

                            console.log("UPLOAD ON COMPLETE ITEM - STATUS", status);

                            if(status !== 200){
                              this.fireAlert('Unknown error happened while uploading!');
                              return 'err';
                            }

                            var imageResponse = JSON.parse(response);
                            //console.log('ITEM:::::::', item);
                            console.log('RESPONSE:::', imageResponse);
                            // Check if upload was of type add-on or type main
                            if(imageResponse.success){
                                
                                if (this.uploadImageType == 'order') {this.fireAlert(imageResponse.message)};
                                

                                if (this.uploadImageType != 'order') {

                                    let toast = this.toastCtrl.create({
                                        message: imageResponse.message,
                                        duration: 2000,
                                        position: 'bottom'
                                      });
                                    toast.present();
                                
                                    let image = imageResponse.data.image;

                                    if (image) {
                                      //Update image locally
                                      let index = this.orders[0].images.findIndex(item => item.id == image.id);
                                      if (index !== -1) {
                                       this.orders[0].images[index] = image;
                                      }

                                     // Check if image was last image of images
                                      console.log("IMAGES::::", this.orders[0].images);
                                    }
                                    
                              }
                                

                                if (this.uploadImageType == 'main') {
                                  let openImages = this.orders[0].images.filter(item => item.status < 100);
                                  console.log("OPEN IMAGES:", openImages);
                                  if (openImages.length == 0) {
                                    this.completeOrder(this.orders[0]);
                                    this.fireCompleteOrderNotification();
                                  }
                                }

                                // if (this.uploadImageType == 'add-on') {
                                //   let image = imageResponse.data;

                                //   // Update image locally
                                //   let index = this.images.findIndex(item => item.id == image.id);
                                //   if (index !== -1) {
                                //    this.images[index] = image;
                                //   }

                                //   console.log("Add On Upload Result", imageResponse);
                                // }else{
                                //   this.images.push(imageResponse.data);
                                // }
                                
                                  
                            }else{
                              //Response error
                              this.fireAlert(imageResponse.message);
                              console.log('Response Error!', imageResponse);
                            }

                            //console.log(this.images);


                            upsertResponse(
                            {
                                file: item.file,
                                status,
                                data: JSON.parse(response)
                            }
                        );
                  };


                this.uploader.onProgressItem = (fileItem: any, progress: any) =>
                  {
                    this.uploadProgress = progress;
                    upsertResponse(
                        {
                            file: fileItem.file,
                            progress
                        }
                    );
                  };

                this.uploader.onCompleteAll = () => {
                    if(this.loading){ this.loading.dismiss(); this.loading = undefined };
                    this.closeSimpleLoader();

                    this.loading = null;
                  };
                //this.uploader.onCompleteAll = (item: any) => this.loading.dismiss();
        });
    


    //this.getOrders();
    //console.log("Orders:");
    //console.log(this.orders);
  }

  openDownloadModal(url:string, platform:string){
    console.log("OPEN DOWNLOAD MODAL WITH URL:", url);
    console.log("OPEN DOWNLOAD MODAL FOR PLATFORM:", platform);
    const createModal: any = this.modalCtrl.create('DownloadModalPage', { lang: 'en', downloadUrl: url, downloadPlatform: platform });
       createModal.present(); 
  }

  refreshOrders() {
    this.getPage(1);
  }

  getPage(page: number) {
    let searchOrderId = this.search_Order_Id;

    this.showLoader();
    this.orderService.getAdminOrders(page, searchOrderId).then((data: any) => {
        console.log('DATAA from Page:', data);
          this.res = data;
          this.orders = data.data;
          

          this.total = this.res.total;
          this.per_page = this.res.per_page;
          this.p = this.res.current_page;

          const perPage = 10;
          const start = (page - 1) * perPage;
          const end = start + perPage;

          if(this.loading){ this.loading.dismiss(); this.loading = undefined };
          this.closeSimpleLoader();

    }, (err) => {
        if(this.loading){ this.loading.dismiss(); this.loading = undefined };
        this.closeSimpleLoader();
        this.fireToast(err.json().error);
        console.log("not allowed_____");
        console.log(err);
    });


    }

  pageChanged(event){
    this.getPage(event);
  }

  openSpecsModal(type:string){
    const modal: any = this.modalCtrl.create('SpecsModalPage', { type: type });
    modal.present(); 

    // this.navCtrl.push('SpecsModalPage', {
    //   type: type
    // })
  }

  openOrderDetails(id) {
    this.navCtrl.push('CreateOrderPage', {
      orderId: id
    })
  }

  fireCompleteOrderNotification() {
    this.fireToast("Looks like all images have been completed. Please don't forget to press the 'Complete' button");
  }

  blockOrder(order){
                    this.orderService.blockOrder(order).then((data: any) => {
                        console.log('DATAA from COMPLETE ORDER:', data);
                          this.fireToast(data.message);
                          this.orders[0].is_blocked_by_admin = true;

                    }, (err) => {
                        
                        console.log("Error in Order completion", err);
                        this.fireToast(err.json().message);
                    });
  }

  getStreamDownloadPackageURL(order, offset){
    const url = this.global.apiUrl + "download-all-order-images-stream?hash=" + order.hash + "&offset=" + offset;
    return url;
  }

  downloadAllOrderImages(order, offset){
    console.log("Donwload All Images for Order");
    console.log("Download for offset", offset)

    this.showLoader();
     this.orderService.downloadAllOrderImages(order.id, offset).then((result: any) => {
            console.log("Download all orders result:", result);
            if(this.loading){ this.loading.dismiss(); this.loading = undefined };
            let fileURL = result.data;

                  // Notifiy Admin about download URL
                  //  fileURL
                  //this.fireAlert("Download URL: " + fileURL);
                  this.openDownloadModal(fileURL, 'core');
  
                  // this.orderService.getFile(fileURL)
                  //     .subscribe(fileData => {
                  //       let b: any = new Blob([fileData], { type: 'application/zip' });
                  //       var url = window.URL.createObjectURL(b);
                  //       window.open(url);
                  //     }
                  //   );

                  // Get File for CORE
                  // this.orderService.getFile(fileURL)
                  // .subscribe(fileData => 
                  //   {
                  //   let b:any = new Blob([fileData], { type: 'zip' });
                  //   var url= window.URL.createObjectURL(b);
                  //     window.open(url); 
                  //   }
                  // );



                  //return false;
                
            

 

            //Navigate to Publisher
        }, (err) => {
            if(this.loading){ this.loading.dismiss(); this.loading = undefined };
            this.fireAlert(err.json().message);
    });
  }

  completeOrder(order){

     let prompt = this.alertCtrl.create({
      title: "Complete order",
      message: "All images done ? Order will disappear from backend after completion.",
      buttons: [
        {
          text: "Cancel"
        },
        {
          text: "Complete",
          handler: complete => { 
                    this.showLoader();
                    this.orderService.completeOrder(order).then((data: any) => {
                        console.log('DATAA from COMPLETE ORDER:', data);
                          this.fireToast(data.message);
                          if(this.loading){ this.loading.dismiss(); this.loading = undefined };
                          this.getPage(1);

                    }, (err) => {
                        if(this.loading){ this.loading.dismiss(); this.loading = undefined };
                        console.log("Error in Order completion", err);
                        this.fireToast(err.json().message);
                    });
          }
        }
      ]
    });
 
    prompt.present();



    



  }

  rejectImage(image){
    let alert = this.alertCtrl.create();
    alert.setTitle('Please select the rejection reason');

    alert.addInput({
      type: 'checkbox',
      label: 'Not possible',
      value: 'not_possible',
      checked: true
    });

    alert.addInput({
      type: 'checkbox',
      label: 'Too difficult',
      value: 'to_difficult'
    });

    alert.addInput({
      type: 'checkbox',
      label: 'Wrong size',
      value: 'wrong_size'
    });

    alert.addButton('Cancel');
    alert.addButton({
      text: 'Reject',
      handler: rejection => {
        console.log('Checkbox data:', rejection);
        
          if(rejection){
              image.rejection_reasons = rejection;
              this.showLoader();
              image.disapproved_text = rejection.disapproved_text;
              this.orderService.rejectAdminImage(image).then((result: any) => {
                  if(this.loading){ this.loading.dismiss(); this.loading = undefined };
                  this.fireToast(result.message);
                  console.log('Disapproval result', result);
                  //Update locally

                  
              }, (err) => {
                  if(this.loading){ this.loading.dismiss(); this.loading = undefined };
                  this.fireAlert(err.json().message);
                  console.log("not allowed");
              });

          }

        }
    });
    alert.present();
  }

  // rejectImage(image){
 
  //   let prompt = this.alertCtrl.create({
  //     title: this.translate.instant("ORDER.REJECT_IMAGE_TITLE"),
  //     message: this.translate.instant("ORDER.REJECT_IMAGE_DESC"),
  //     inputs: [
  //       {
  //         name: 'disapproved_text'
  //       }
  //     ],
  //     buttons: [
  //       {
  //         text: this.translate.instant("BUTTONS.CANCEL")
  //       },
  //       {
  //         text: this.translate.instant("BUTTONS.SAVE"),
  //         handler: rejection => {
 
  //               if(rejection){
 
  //                   this.showLoader();
  //                   image.disapproved_text = rejection.disapproved_text;
  //                   this.orderService.rejectAdminImage(image).then((result: any) => {
  //                       if(this.loading){ this.loading.dismiss(); this.loading = undefined };
  //                       this.fireAlert(result.message);
  //                       console.log('Disapproval result', result);
  //                       //Update locally

                        
  //                   }, (err) => {
  //                       if(this.loading){ this.loading.dismiss(); this.loading = undefined };
  //                       this.fireAlert(err.json().message);
  //                       console.log("not allowed");
  //                   });
 
  //               }
 
 
  //         }
  //       }
  //     ]
  //   });
 
  //   prompt.present();
 
  // }


  changeUploadImageType(type, image, swatch, order){
    this.uploadImageType = type;
    console.log('SWATCH', swatch);
    if (swatch) {
      this.forImageId = image.id;
      this.imageSwatch = swatch;
    }else{
      if(image){
        this.forImageId = image.id;
      }
      if(order){
        this.forOrderId = order.id;
      }
      
    }
    console.log('this.uploadImageType', this.uploadImageType);
    console.log('this.forImageId', this.forImageId);
    console.log('this.image_swatch', this.imageSwatch);
  }

  showSimpleLoader(){
    this.loader = true;
  }

  closeSimpleLoader(){
    this.loader = false;
  }

  showLoader(){
 
    this.loading = this.loadingCtrl.create({
      content: 'Loading...'
    });
 
    this.loading.present();
 
  }
 
  logout(){
 
    this.authService.logout();
    this.navCtrl.setRoot('LoginPage');
 
  }

  open_help(type:string){
    if (type == 'free_image') {
      this.fireAlert('This image can be rejected with the reason "Too Difficult" if it is obvious that it is not a proper product photo. (Animals, People, Stock Photos, Sketches, Paintings)');
    }
  }

  fireToast(message: string) {
    console.log('fire toast!');
    let toast = this.toastCtrl.create({
                                    message: message,
                                    duration: 3000,
                                    position: 'bottom'
                                  });
                toast.present();
  }

  fireAlert(message: string) {
    let alert = this.alertCtrl.create({
                                    message: message,
                                    //duration: 2000,
                                    //position: 'bottom'
                                  });
    alert.present();
  }

  public fileOverBase(e: any, type:string, image:any, swatch:any, order:any): void {
        this.hasBaseDropZoneOver = e;

            this.uploadImageType = type;
            if (swatch) {
              this.forImageId = image.id;
              this.imageSwatch = swatch
            }else{
              if(image){
                this.forImageId = image.id;
              }
              if(order){
                this.forOrderId = order.id;
              }
            }
            console.log('this.uploadImageType', this.uploadImageType);
            console.log('this.forImageId', this.forImageId);
            console.log('this.image_swatch', this.imageSwatch);
  }

}



// WEBPACK FOOTER //
// ./src/pages/orders/orders.ts